import React, {useCallback, useEffect, useRef, useState} from 'react';
import axios from '../../../services/axiosInstance';
import '../../../css/web/AdminOrderList.css'
import MsgSelectModal from "./MsgSelectModal";
import {FiMinus, FiPlus} from "react-icons/fi";
import {BiCaretDown} from "react-icons/bi";

function TariffCustomModal() {

    const LCAT = localStorage.getItem('adminToken');

    const [ordTariffData, setOrdTariffData] = useState([]);
    const [ordCustom, setOrdCustom] = useState([]);
    const [expandedState, setExpandedState] = useState({});

    const customCurrencyList = ['KRW', 'USD', 'CAD', 'AUD', 'NZD', 'EUR', 'JPY', 'SGD'];

    const toggleExpand = (index) => {
        setExpandedState(prevState => ({
            ...prevState,
            [index]: !prevState[index]
        }));
        // [+] 아코디언을 열거나 닫을 때 모든 드롭다운 닫기
        setParentItemShow({});
        setChildItemShow({});
        setParentCurrencyShow({});
        setChildCurrencyShow({});
    };

    // 여기서부터 부모 커스텀셀렉트
    const [parentItemShow, setParentItemShow] = useState({});
    const [parentSearchText, setParentSearchText] = useState({});
    const [parentCurrencyShow, setParentCurrencyShow] = useState({}); // 부모 통화

    const toggleParentItemShow = (index) => {
        setParentItemShow({ [index]: true }); // 해당 부모 드롭다운만 열기
        setChildItemShow({});
    };

    const handleParentSearchChange = (index, value) => {
        setParentSearchText(prev => ({ ...prev, [index]: value }));
    };

    const handleParentItemChange = (selectedItem, parentIndex) => {
        const updatedData = ordTariffData.map((item, i) => {
            if (i === parentIndex) {
                return {
                    ...item,
                    selectedCustom: selectedItem.seqNum,
                    customsDTO: {
                        ...item.customsDTO,
                        // ✅ 각 필드값 저장
                        customItemDTO: selectedItem,
                        hscode: selectedItem.hsCode,
                        custContent: selectedItem.hsCodeEnNm,
                        mcNm: selectedItem.mcNm,       // 제조사상호
                        mcAddress: selectedItem.mcAddress,       // 제조사주소
                        mcZipcode: selectedItem.mcZipcode,       // 제조사우편번호
                    }
                };
            }
            return item;
        });
        setOrdTariffData(updatedData);
        setParentItemShow({}); // 드랍다운 전부닫기
    };

    const handleParentInputChange = (value, index, field) => {
        const updatedData = ordTariffData.map((item, i) => {
            if (i !== index) return item;

            let processedValue = value;

            if (field === 'custPrice') {
                let sanitized = value.replace(/[^0-9.]/g, '');
                const parts = sanitized.split('.');
                if (parts.length > 2) sanitized = parts[0] + '.' + parts.slice(1).join('');
                // 💡 부모 단가 입력 제한도 2자리에서 5자리로 확장
                if (parts[1] && parts[1].length > 5) sanitized = parts[0] + '.' + parts[1].substring(0, 5);
                processedValue = formatCurrency(sanitized);
            }
            if (field === 'custQty') {
                processedValue = value.replace(/\D/g, '');
            }

            return {
                ...item,
                customsDTO: {
                    ...item.customsDTO,
                    [field]: processedValue
                }
            };
        });
        setOrdTariffData(updatedData);
    };

    // 부모 통화 토글
    const toggleParentCurrencyShow = (index, e) => {
        e.stopPropagation();
        setParentCurrencyShow(prev => ({ [index]: !prev[index] })); // 해당 인덱스만 토글, 나머지 닫힘
        setChildCurrencyShow({});
    };

    // 부모 통화 변경
    const handleParentCurrencyChange = (index, value) => {
        const updatedData = ordTariffData.map((item, i) => {
            if (i !== index) return item;
            return {
                ...item,
                customsDTO: { ...item.customsDTO, custCurrency: value }
            };
        });
        setOrdTariffData(updatedData);
        setParentCurrencyShow({});
    };
    // 여기까지 부모 커스텀셀렉트


    // 여기서부터 자식 커스텀셀렉트
    const [childItemShow, setChildItemShow] = useState({});
    const [childCurrencyShow, setChildCurrencyShow] = useState({});
    const [childSearchText, setChildSearchText] = useState({});

    const toggleChildItemShow = (parentIndex, childIndex) => {
        const key = `${parentIndex}-${childIndex}`;
        setChildItemShow({ [key]: true });
        setParentItemShow({});
    };

    const handleChildSearchChange = (parentIndex, childIndex, value) => {
        const key = `${parentIndex}-${childIndex}`;
        setChildSearchText(prev => ({ ...prev, [key]: value }));
    };

    const handleChildItemChange = (selectedItem, parentIndex, childIndex) => {
        const updatedData = ordTariffData.map((parentItem, pIndex) => {
            // 현재 수정하려는 부모 아이템이 아니면 그대로 반환
            if (pIndex !== parentIndex) {
                return parentItem;
            }

            // 부모 아이템 내부의 자식 아이템 리스트(customItemsDTO)를 새로 만듦
            const newCustomItems = parentItem.customsDTO.customItemsDTO.map((childItem, cIndex) => {
                // 현재 수정하려는 자식 아이템이 아니면 그대로 반환
                if (cIndex !== childIndex) {
                    return childItem;
                }

                // 수정하려는 자식 아이템을 찾아 새로운 객체로 만들어 반환
                return {
                    ...childItem,
                    customItemDTO: selectedItem,         // 선택된 HS CODE 정보 전체를 저장
                    content: selectedItem.hsCodeEnNm,    // 내용(content) 자동 완성
                    hscode: selectedItem.hsCode,           // hscode 필드 추가 및 업데이트
                    mcNm: selectedItem.mcNm,       // 제조사상호
                    mcAddress: selectedItem.mcAddress,       // 제조사주소
                    mcZipcode: selectedItem.mcZipcode,       // 제조사우편번호
                };
            });

            // 새로운 자식 아이템 리스트를 포함하는 새로운 부모 아이템 객체를 반환
            return {
                ...parentItem,
                customsDTO: {
                    ...parentItem.customsDTO,
                    customItemsDTO: newCustomItems,
                },
            };
        });

        setOrdTariffData(updatedData);
        setChildItemShow({}); // 드랍다운 전부닫기
    };

    // 자식 통화 토글
    const toggleChildCurrencyShow = (parentIndex, childIndex, e) => {
        e.stopPropagation();
        const key = `${parentIndex}-${childIndex}`;
        setChildCurrencyShow(prev => ({ [key]: !prev[key] })); // 해당 키만 토글
        setParentCurrencyShow({});
    };

    // 자식 통화 변경
    const handleChildCurrencyChange = (parentIndex, childIndex, value) => {
        const updatedData = ordTariffData.map((parentItem, pIndex) => {
            if (pIndex !== parentIndex) return parentItem;

            const newCustomItems = parentItem.customsDTO.customItemsDTO.map((childItem, cIndex) => {
                if (cIndex !== childIndex) return childItem;
                return { ...childItem, currency: value };
            });

            return {
                ...parentItem,
                customsDTO: { ...parentItem.customsDTO, customItemsDTO: newCustomItems }
            };
        });
        setOrdTariffData(updatedData);
        setChildCurrencyShow({});
    };
    // 여기까지 자식 커스텀셀렉트

    // ✅ 부모의 기본 정보(내용, 가격) 변경 핸들러
    const handleInputChange = (value, index, field) => {
        const updatedData = ordTariffData.map((item, i) => {
            if (i === index) {
                return {
                    ...item,
                    customsDTO: {
                        ...item.customsDTO,
                        [field]: value
                    }
                };
            }
            return item;
        });
        setOrdTariffData(updatedData);
    };

    const handleParentQuantityChange = (value, index) => {
        const updatedData = ordTariffData.map((item, i) => {
            if (i === index) {
                return {
                    ...item,
                    customsDTO: {
                        ...item.customsDTO,
                        custQty: value.replace(/\D/g, '') // 숫자만
                    }
                };
            }
            return item;
        });
        setOrdTariffData(updatedData);
    };

    const [alertShow, setAlertShow] = useState(false);
    const msgConfirmData1 = "세관정보를 수정 하시겠습니까?";
    const msgConfirmData2 = "입력한 정보를 다시한번 확인해주세요.";
    const modalCancel1 = useCallback(() => {
        setAlertShow(false);
    })

    // 콤마 제거
    const unformat = (value) => {
        return String(value).replace(/,/g, '');
    };

    // 통화 포맷팅 (콤마 + 소수점 2자리)
    const formatCurrency = (value) => {
        if (value === null || value === undefined || value === '') return '';
        let strValue = unformat(value);
        const parts = strValue.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        if (parts.length > 1) {
            return parts[0] + '.' + parts[1].substring(0, 5);
        } else {
            return parts[0];
        }
    };

    // --- 초기 데이터 로드 ---
    useEffect(() => {
        const receivedData = JSON.parse(localStorage.getItem('ordReceiptData'));
        localStorage.removeItem('ordReceiptData');

        if (receivedData) {
            const dataWithSelectedCustom = receivedData.map(item => ({
                ...item,
                customsDTO: {
                    ...item.customsDTO,
                    // 부모 가격 포맷팅 적용
                    custPrice: formatCurrency(item.customsDTO.custPrice),
                    // 부모 통화 없으면 USD
                    custCurrency: item.customsDTO.custCurrency || "USD",
                    customItemsDTO: (item.customsDTO.customItemsDTO || []).map(child => ({
                        ...child,
                        // 자식 가격들 포맷팅 적용
                        price: formatCurrency(child.price),
                        ttPrice: formatCurrency(child.ttPrice),
                        // 자식 통화 없으면 USD
                        currency: child.currency || "USD"
                    }))
                },
                selectedCustom: item.customsDTO.customItemDTO?.seqNum,
            }));
            setOrdTariffData(dataWithSelectedCustom);
        }
        customItemSelect();
    }, []);

    const customItemSelect = () => {
        axios.get('/admincustomitem/admincustomitemselect')
            .then((response) => {
                setOrdCustom(response.data);
            }, [])
            .catch(() => {})
    }

    const isEmpty = (val) => val === undefined || val === null || String(val).trim() === "";

    const validCheck = () => {
        let isInvalid = false;

        for (const parent of ordTariffData) {
            const parentCustoms = parent.customsDTO;

            // 부모 필드 검사 (0 허용을 위해 loose 느김표 체크 제거)
            if (isEmpty(parentCustoms.custContent) || isEmpty(parentCustoms.custPrice) || !parentCustoms.customItemDTO) {
                isInvalid = true;
                break;
            }

            // 자식 필드 검사 (0 혹은 "0" 입력 시 정상 통과하도록 수정)
            if (parentCustoms.customItemsDTO && parentCustoms.customItemsDTO.length > 0) {
                for (const child of parentCustoms.customItemsDTO) {
                    if (isEmpty(child.content) || isEmpty(child.quantity) || isEmpty(child.price) || !child.customItemDTO) {
                        isInvalid = true;
                        break;
                    }
                }
            }
            if (isInvalid) break;
        }

        if (isInvalid) {
            setFieldNullErr(true);
        } else {
            setFieldNullErr(false);
            setAlertShow(true);
        }
    };

    // const validCheck = () => {
    //     let isInvalid = false;
    //
    //     for (const parent of ordTariffData) {
    //         const parentCustoms = parent.customsDTO;
    //
    //         // 부모 필드 검사
    //         if (!parentCustoms.custContent || !parentCustoms.custPrice || !parentCustoms.customItemDTO) {
    //             isInvalid = true;
    //             break;
    //         }
    //
    //         // 자식 필드 검사 (자식이 있을 경우에만)
    //         if (parentCustoms.customItemsDTO && parentCustoms.customItemsDTO.length > 0) {
    //             for (const child of parentCustoms.customItemsDTO) {
    //                 if (!child.content || !child.quantity || !child.price || !child.customItemDTO) {
    //                     isInvalid = true;
    //                     break;
    //                 }
    //             }
    //         }
    //         if (isInvalid) break;
    //     }
    //
    //     if (isInvalid) {
    //         setFieldNullErr(true);
    //     } else {
    //         setFieldNullErr(false);
    //         setAlertShow(true);
    //     }
    // };

    const [fieldNullErr, setFieldNullErr] = useState(false);
    // DB업데이트
    const ordTariffUpdate = () => {
        const updatedTariffData = ordTariffData.map(entry => {
            // 부모 아이템에 자식 아이템(customItemsDTO)이 있는지 확인합니다. 없으면 빈 배열로 처리합니다.
            const children = entry.customsDTO.customItemsDTO || [];

            // 자식 아이템이 있을 경우, 총 수량과 총 가격을 계산
            const totalQuantity = children.reduce((sum, item) => sum + (Number(item.quantity) || 0), 0);
            const totalPrice = children.reduce((sum, item) => sum + (parseFloat(unformat(item.ttPrice)) || 0), 0); // 개별 총가(ttPrice)의 합으로 계산

            // 자식이 있으면 자식 합계 사용, 없으면 부모 입력값 사용 (unformat 적용)
            const custQty = children.length > 0 ? totalQuantity : (parseInt(unformat(entry.customsDTO.custQty)) || 0);
            const custPrice = children.length > 0 ? totalPrice : (parseFloat(unformat(entry.customsDTO.custPrice)) || 0);
            // 자식이 있으면 첫 번째 자식의 통화 사용 (혹은 부모 선택 통화 유지 정책에 따라 변경 가능)
            const custCurrency = children.length > 0 ? (children[0].currency || "USD") : (entry.customsDTO.custCurrency || "USD");

            // price와 ttPrice에서 콤마를 완전히 제거하고 pure number(또는 깨끗한 숫자 문자열)로 변환
            const sanitizedChildren = children.map(child => {
                // customItemDTO 객체 구조가 있다면 불필요한 플래그나 UI 상태값은 분리하고 백엔드 사양에 맞춤
                const { isTotalManual, ...rest } = child;
                return {
                    ...rest,
                    quantity: parseInt(unformat(child.quantity) || 0, 10),
                    price: parseFloat(unformat(child.price) || 0),     // 예: "1,433.74725" -> 1433.74725 (BigDecimal 파싱 가능)
                    ttPrice: parseFloat(unformat(child.ttPrice) || 0), // 예: "1,433.74725" -> 1433.74725
                    currency: child.currency || "USD"
                };
            });

            // 기존 customsDTO의 모든 정보를 그대로 유지하면서, 계산된 custQty와 custPrice만 덮어쓰기
            return {
                ...entry.customsDTO,
                custQty,
                custPrice,
                custCurrency,
                customItemsDTO: sanitizedChildren.length > 0 ? sanitizedChildren : null
            };
        });

        // API 호출 부분은 동일
        axios.post('/order/ordCustomsUpdate', updatedTariffData, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization' : LCAT
            }
        })
            .then(() => {
                setAlertShow(false);
                if (window.opener) {
                    window.opener.location.reload();
                    window.close();
                }
            })
            .catch(error => {
                console.error("Error:", error);
            });
    };

    const handleItemChange = (parentIndex, childIndex, field, value) => {
        const updatedData = ordTariffData.map((parentItem, pIndex) => {
            if (pIndex !== parentIndex) return parentItem;

            const newCustomItems = parentItem.customsDTO.customItemsDTO.map((childItem, cIndex) => {
                if (cIndex !== childIndex) return childItem;

                let processedValue = value;

                // 수량은 숫자만 허용
                if (field === 'quantity') {
                    processedValue = value.replace(/\D/g, '');
                }

                // 단가/총가는 소수점 최대 5자리 허용으로 정제 로직 변경
                if (field === 'price' || field === 'ttPrice') {
                    let sanitized = value.replace(/[^0-9.]/g, '');
                    const parts = sanitized.split('.');
                    if (parts.length > 2) sanitized = parts[0] + '.' + parts.slice(1).join('');
                    if (parts[1] && parts[1].length > 5) sanitized = parts[0] + '.' + parts[1].substring(0, 5);
                    processedValue = formatCurrency(sanitized);
                }

                const updatedChildItem = { ...childItem, [field]: processedValue };

                if (field === 'ttPrice') {
                    updatedChildItem.isTotalManual = true;
                }

                if ((field === 'quantity' || field === 'price') && !updatedChildItem.isTotalManual) {
                    updatedChildItem.isTotalManual = false;
                    const quantityNum = parseFloat(unformat(updatedChildItem.quantity)) || 0;
                    const priceNum = parseFloat(unformat(updatedChildItem.price)) || 0;
                    const total = quantityNum * priceNum;

                    let totalStr;
                    if (total % 1 === 0) totalStr = total.toString();
                    else totalStr = total.toFixed(5);

                    updatedChildItem.ttPrice = formatCurrency(totalStr);
                }

                return updatedChildItem;
            });

            return {
                ...parentItem,
                customsDTO: { ...parentItem.customsDTO, customItemsDTO: newCustomItems }
            };
        });
        setOrdTariffData(updatedData);
    };

    // ✅ 자식 아이템 추가
    const addCustomItem = (parentIndex) => {
        const updatedData = [...ordTariffData];
        const parentItem = updatedData[parentIndex];

        // 불변성을 지키며 새로운 리스트 생성
        parentItem.customsDTO.customItemsDTO = [
            ...parentItem.customsDTO.customItemsDTO,
            {
                customItemDTO: null, // ✅ 초기 customItemDTO 필드 추가
                content: "",
                quantity: "",
                price: "",
                ttPrice: "",
                currency: "USD",
                hscode: null,
                mcNm: null,
                mcAddress: null,
                mcZipcode: null,
                isTotalManual: false
            }
        ];
        setOrdTariffData(updatedData);
    };

    // ✅ 자식아이템 삭제
    const removeCustomItem = (parentIndex, childIndex) => {
        const updatedData = ordTariffData.map((parentItem, pIndex) => {
            if (pIndex !== parentIndex) {
                return parentItem;
            }

            // ✅ customItemsDTOList -> customItemsDTO 로 변경
            const newCustomItems = parentItem.customsDTO.customItemsDTO.filter((_, cIndex) => cIndex !== childIndex);

            return {
                ...parentItem,
                customsDTO: {
                    ...parentItem.customsDTO,
                    customItemsDTO: newCustomItems // ✅ 변경된 배열로 교체
                }
            };
        });
        setOrdTariffData(updatedData);
    };

    useEffect(() => {
        // ordCustom 데이터가 없으면 실행하지 않음
        if (ordCustom.length === 0) return;

        // 함수형 업데이트를 사용하여 ordTariffData에 대한 직접 의존성 제거
        setOrdTariffData(currentData => {
            // 현재 데이터가 비어있으면 원본 그대로 반환
            if (currentData.length === 0) return currentData;

            // 업데이트가 필요한지 먼저 확인 (불필요한 연산 방지)
            const needsUpdate = currentData.some(parent =>
                parent.customsDTO.customItemsDTO.some(child => child.hscode && !child.customItemDTO)
            );

            if (!needsUpdate) {
                return currentData; // 업데이트 필요 없으면 원본 state를 그대로 반환하여 렌더링 방지
            }

            const hsCodeMap = new Map(ordCustom.map(item => [item.hsCode, item]));

            return currentData.map(parent => ({
                ...parent,
                customsDTO: {
                    ...parent.customsDTO,
                    customItemsDTO: parent.customsDTO.customItemsDTO.map(child => {
                        if (child.hscode && !child.customItemDTO) {
                            const matchingCustomItem = hsCodeMap.get(child.hscode);
                            return {
                                ...child,
                                customItemDTO: matchingCustomItem || null,
                            };
                        }
                        return child;
                    }),
                },
            }));
        });
        // 의존성 배열에서 ordTariffData를 제거하고, ordCustom만 남겨 둠
    }, [ordCustom]);

    useEffect(() => {
        if (ordTariffData.length === 0) return;

        const initialParentSearchText = {};
        const initialChildSearchText = {};

        ordTariffData.forEach((parent, i) => {
            // 부모 hsCodeNm 초기값
            initialParentSearchText[i] =
                parent.customsDTO?.customItemDTO?.hsCodeNm || "";

            // 자식 hsCodeNm 초기값
            if (parent.customsDTO?.customItemsDTO) {
                parent.customsDTO.customItemsDTO.forEach((child, j) => {
                    initialChildSearchText[`${i}-${j}`] =
                        child.customItemDTO?.hsCodeNm || "";
                });
            }
        });

        setParentSearchText(initialParentSearchText);
        setChildSearchText(initialChildSearchText);
    }, [ordTariffData]);

    const handleModalClick = (event) => {
        // hscode 및 currency 드랍다운 외부 영역 클릭 시 닫기
        if (!event.target.closest('.parent-hscode-container')) setParentItemShow({});
        if (!event.target.closest('.child-hscode-container')) setChildItemShow({});
        if (!event.target.closest('.parent-currency-selector')) setParentCurrencyShow({});
        if (!event.target.closest('.child-currency-selector')) setChildCurrencyShow({});
    };


    return (
        <div className="TariffCustomModal admin-modal-default">
            <div className="openModal regModal">
                <section onClick={handleModalClick}>
                    <header className="admin-work-title">
                        <b style={{color: "#ffffff"}}>세관신고금액 및 내용품명 작성</b>
                    </header>
                    <main>
                        <div className="div-tb m-b-10" style={{minHeight:"800px"}}>
                            <div className="div-tb-head ht-50">
                                <div style={{width: "60px"}}><p></p></div>
                                <div style={{width: "140px"}}><p>주문번호</p></div>
                                <div style={{width: "120px"}}><p>수취인명</p></div>
                                <div style={{width: "200px"}}><p>내용품명</p></div>
                                <div style={{width: "70px"}}><p>수량</p></div>
                                <div style={{width: "70px"}}><p>금액</p></div>
                                <div style={{width: "70px"}}><p>통화</p></div>
                                <div style={{width: "120px"}}><p>HS CODE</p></div>
                            </div>
                            {ordTariffData?.map((tData, i) => (
                                <div key={i} className="div-tb-body2" style={{padding: "20px 0"}}>
                                    <div className="display-flex align-center justify-content-around wd-100pc">
                                        <div className="wd-60">
                                            <button onClick={() => toggleExpand(i)}
                                                    className="admin-btn-B wd-45 ht-30">
                                                {expandedState[i] ? <FiMinus/> : <FiPlus/>}
                                            </button>
                                        </div>

                                        <div className="wd-140">
                                            <p className="font-b font-s-13">…{tData.orderdtDTO.orderNumber.slice(-7)} - {tData.shipInfoDTO.boxNum}</p>
                                        </div>
                                        <div className="wd-120">
                                            <p className="font-b font-s-13">{tData.appRecDTO.recname}</p>
                                        </div>
                                        <div className="wd-200">
                                            <input className="admin-input-line ht-30 p-l-5 font-s-13"
                                                   style={{width: "180px"}} type="text" maxLength={450}
                                                   placeholder="세관품목 내용을 입력하세요." value={tData.customsDTO.custContent}
                                                   onChange={(e) => handleInputChange(e.target.value, i, 'custContent')}/>
                                        </div>
                                        <div className="wd-70 m-r-5">
                                            <input
                                                className="admin-input-line wd-100pc ht-30 text-center font-s-13"
                                                type="text"
                                                placeholder="수량"
                                                value={tData.customsDTO.custQty || ''}
                                                onChange={(e) => handleParentQuantityChange(e.target.value, i)}
                                            />
                                        </div>

                                        <div className="wd-70 m-r-5">
                                            <input
                                                className="admin-input-line wd-100pc ht-30 text-center font-s-13 font-c-progress font-b"
                                                minLength={1} maxLength={20} type="text"
                                                placeholder="0" value={tData.customsDTO.custPrice.toLocaleString()}
                                                onChange={(e) => handleParentInputChange(e.target.value, i, 'custPrice')}/>
                                        </div>

                                        {/*부모 통화 셀렉트박스*/}
                                        <div className="wd-70 m-r-5">
                                        <div className="wd-100pc ht-30 position-relative">
                                            <button className="selectParentBt wd-100pc ht-100pc" onClick={(e) => toggleParentCurrencyShow(i, e)}>
                                                <p style={{
                                                    margin: "0",
                                                    fontSize: "12px",
                                                    padding: "0 5px"
                                                }}>{tData.customsDTO.custCurrency || "USD"}</p>
                                            </button>
                                            {parentCurrencyShow[i] && (
                                                <div style={{
                                                    position: "absolute",
                                                    width: "200%",
                                                    border: "1px solid lightgray",
                                                    backgroundColor: "white",
                                                    zIndex: 999,
                                                    top: "120%",
                                                    left: 0,
                                                    maxHeight: "200px",
                                                    overflowY: "auto"
                                                }}>
                                                    {customCurrencyList.map((cur, idx) => (
                                                        <div
                                                            className="selectChildBt user-center pd5 c-point font-s-12"
                                                            key={idx}
                                                            onClick={() => handleParentCurrencyChange(i, cur)} // Index, Value 전달
                                                            style={{ padding: '5px' }}
                                                        >
                                                            {cur}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                        </div>

                                        <div style={{width: "120px"}}>
                                            {/*부모아이템*/}
                                            <div className="parent-hscode-container" style={{width: "100%", position: "relative"}}>
                                                <input
                                                    style={{padding:"0 5px"}}
                                                    className="admin-input-line ht-30 font-s-12 wd-100pc text-center"
                                                    placeholder="HScode"
                                                    value={parentSearchText[i] ?? (tData.customsDTO.customItemDTO?.hsCodeNm || "")}
                                                    onChange={(e) => handleParentSearchChange(i, e.target.value)}
                                                    onFocus={() => toggleParentItemShow(i)}
                                                />
                                                {parentItemShow[i] && (
                                                    <div
                                                        style={{
                                                        width: "200px",
                                                        border: "solid 1px lightgray",
                                                        position: "absolute",
                                                        top: "120%",
                                                        right: 0,
                                                        backgroundColor: "white",
                                                        zIndex: 9999,
                                                        maxHeight: "300px",
                                                        overflowY: "auto",
                                                    }}>
                                                        {ordCustom
                                                            .filter(item => !parentSearchText[i] || item.hsCodeNm.includes(parentSearchText[i]))
                                                            .map((item, index) => (
                                                                <div className="selectChildBt user-center pd10 c-point font-s-12 text-center"
                                                                     key={index}
                                                                     onClick={() => handleParentItemChange(item, i)}>
                                                                    {item.hsCodeNm}
                                                                </div>
                                                            ))}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    {expandedState[i] && (
                                        <div className="m-t-20 font-t-cont">
                                            {tData.customsDTO.customItemsDTO?.map((data, j) => (
                                                <div key={j} className="user-center wd-100pc ht-50">
                                                    <div style={{width: "40px"}}>{j + 1}</div>

                                                    {/* 개별내용품명 */}
                                                    <div className="wd-200 m-r-10">
                                                        <input
                                                            className="admin-input-line ht-30 text-center font-s-12 m-l-5 wd-100pc"
                                                            maxLength={100}
                                                            type="text"
                                                            placeholder="개별내용품명"
                                                            value={data.content}
                                                            onChange={e => handleItemChange(i, j, "content", e.target.value)}
                                                        />
                                                    </div>

                                                    {/*자식아이템*/}
                                                    <div className="child-hscode-container wd-100 m-r-10" style={{position: "relative"}}>
                                                        <input
                                                            style={{padding:"0 5px"}}
                                                            className="admin-input-line ht-30 font-s-12 wd-100pc text-center"
                                                            placeholder="HScode"
                                                            value={childSearchText[`${i}-${j}`] ?? (data.customItemDTO?.hsCodeNm || "")}
                                                            onChange={e => handleChildSearchChange(i, j, e.target.value)}
                                                            onFocus={() => toggleChildItemShow(i, j)}
                                                        />
                                                        {childItemShow[`${i}-${j}`] && (
                                                            <div
                                                                style={{
                                                                    width: "200px",
                                                                    border: "solid 1px lightgray",
                                                                    position: "absolute",
                                                                    top: "120%",
                                                                    left: 0,
                                                                    backgroundColor: "white",
                                                                    zIndex: 9999,
                                                                    maxHeight: "300px",
                                                                    overflowY: "auto",
                                                                }}
                                                            >
                                                                {ordCustom.filter(item => !childSearchText[`${i}-${j}`] ||
                                                                    item.hsCodeNm.includes(childSearchText[`${i}-${j}`]))
                                                                    .map((item, index) => (
                                                                        <div
                                                                            className="selectChildBt"
                                                                            key={index}
                                                                            onClick={() => handleChildItemChange(item, i, j)}
                                                                            style={{
                                                                                display: "flex",
                                                                                padding: "10px",
                                                                                justifyContent: "center",
                                                                                alignItems: "center",
                                                                                cursor: "pointer",
                                                                                fontSize: "12px",
                                                                                textAlign: "center"
                                                                            }}>
                                                                            {item.hsCodeNm}
                                                                        </div>
                                                                    ))}
                                                            </div>
                                                        )}
                                                    </div>

                                                    {/* 개별수량 */}
                                                    <div className="wd-70 m-r-5">
                                                        <input
                                                            className="admin-input-line ht-30 text-center font-s-12 m-l-5 wd-100pc"
                                                            maxLength={5}
                                                            type="text"
                                                            placeholder="개별수량"
                                                            value={data.quantity}
                                                            onChange={e => handleItemChange(i, j, "quantity", e.target.value)}
                                                        />
                                                    </div>

                                                    {/* 개별단가 */}
                                                    <div className="wd-100 m-r-5">
                                                        <input
                                                            className="admin-input-line ht-30 text-center font-s-12 m-l-5 wd-100pc"
                                                            maxLength={20}
                                                            type="text"
                                                            placeholder="개별단가"
                                                            value={data.price}
                                                            onChange={e => handleItemChange(i, j, "price", e.target.value)}
                                                        />
                                                    </div>

                                                    {/* 총단가 */}
                                                    <div className="wd-100 m-r-10">
                                                        <input
                                                            className="admin-input-line ht-30 text-center font-s-12 m-l-5 wd-100pc"
                                                            maxLength={20}
                                                            type="text"
                                                            placeholder="총단가"
                                                            value={data.ttPrice}
                                                            onChange={e => handleItemChange(i, j, "ttPrice", e.target.value)}
                                                        />
                                                    </div>

                                                    {/*자식 통화 셀렉트박스*/}
                                                    <div style={{width: "70px"}}>
                                                        <div className="ht-30 wd-50 position-relative">
                                                            <button className="selectParentBt wd-100pc ht-100pc" onClick={(e) => toggleChildCurrencyShow(i, j, e)}>
                                                                <p style={{
                                                                    margin: "0",
                                                                    fontSize: "12px",
                                                                    padding: "0 5px"
                                                                }}>{data.currency || "USD"}</p>
                                                            </button>
                                                            {childCurrencyShow[`${i}-${j}`] && (
                                                                <div style={{
                                                                    position: "absolute",
                                                                    width: "200%",
                                                                    border: "1px solid lightgray",
                                                                    backgroundColor: "white",
                                                                    zIndex: 999,
                                                                    top: "120%",
                                                                    left: 0,
                                                                    maxHeight: "200px",
                                                                    overflowY: "auto"
                                                                }}>
                                                                    {customCurrencyList.map((cur, idx) => (
                                                                        <div
                                                                            className="selectChildBt user-center pd5 c-point font-s-12"
                                                                            key={idx}
                                                                            onClick={() => handleChildCurrencyChange(i, j, cur)} // Index, Value 전달
                                                                            style={{ padding: '5px' }}
                                                                        >
                                                                            {cur}
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div className="user-center">
                                                        <button
                                                            onClick={() => removeCustomItem(i, j)}
                                                            className="admin-btn-B wd-45 ht-30 m-r-5">
                                                            <FiMinus/>
                                                        </button>
                                                        <button
                                                            onClick={() => addCustomItem(i)}
                                                            className="admin-btn-B wd-45 ht-30">
                                                            <FiPlus/>
                                                        </button>
                                                    </div>
                                                </div>
                                            ))}
                                            {(!tData.customsDTO.customItemsDTO || tData.customsDTO.customItemsDTO.length===0) &&
                                                <button onClick={() => addCustomItem(i)}
                                                        className="admin-btn-B wd-45 ht-30 m-t-3"><FiPlus/></button>
                                            }
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </main>
                    <footer>
                        { fieldNullErr &&
                        <div>
                            <p className="font-s-13 font-b" style={{color:"orangered", marginBottom:"10px"}}>열려있는 모든 필드값을 입력해주세요</p>
                        </div>
                        }
                        <div className="user-center">
                        <button className="admin-btn-A wd-100 ht-30 font-s-13 btn-click-event m-r-10" onClick={() => window.close()}>취소</button>
                        <button className="admin-btn-A wd-100 ht-30 font-s-13 btn-click-event" onClick={validCheck}>저장</button>
                        </div>
                    </footer>
                </section>
            </div>
            {alertShow === true ? <MsgSelectModal alertShow={alertShow} eventHandle1={modalCancel1} eventHandle2={ordTariffUpdate} msgData1={msgConfirmData1} msgData2={msgConfirmData2}/> : null}
        </div>
    );
}

export default TariffCustomModal
